// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword,signInWithPopup, updateProfile} from 'firebase/auth';
import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { getFirestore, doc, setDoc, getDoc, updateDoc } from 'firebase/firestore'; // Firestore imports
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAPBogON4w7Vd1148QTBI_Q9tCxzmUuP2k",
  authDomain: "login-and-register-6d0b9.firebaseapp.com",
  projectId: "login-and-register-6d0b9",
  storageBucket: "login-and-register-6d0b9.appspot.com",
  messagingSenderId: "1041924445044",
  appId: "1:1041924445044:web:61927b8dfa87473bbfd221",
  measurementId: "G-CMJNJQT65G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
export { auth, db, updatePassword, EmailAuthProvider, reauthenticateWithCredential, googleProvider, facebookProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup, updateProfile };